(function () {
  const PREVIEW_SLIDE_POSITION = 7;
  const PREVIEW_SLIDE_INDEX = PREVIEW_SLIDE_POSITION - 1;

  if (typeof window.__dynamicPreviewForceThirdSlide !== 'boolean') {
    window.__dynamicPreviewForceThirdSlide = false;
  }

  function isGlobalThirdSlideLockEnabled() {
    return window.__dynamicPreviewForceThirdSlide === true;
  }

  function enableGlobalThirdSlideLock() {
    window.__dynamicPreviewForceThirdSlide = true;
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function trimValue(value) {
    return String(value || '').trim();
  }

  function safeParseJson(value, fallback) {
    if (!value) return fallback;
    try {
      const parsed = JSON.parse(value);
      if (typeof parsed === 'string') {
        try {
          return JSON.parse(parsed);
        } catch (_error) {
          return fallback;
        }
      }
      return parsed;
    } catch (_error) {
      return fallback;
    }
  }

  function getProductJson() {
    const script = document.querySelector('script[type="application/json"][data-product-json]');
    if (script) {
      const parsed = safeParseJson(script.textContent, null);
      if (parsed && Array.isArray(parsed.variants)) return parsed;
    }

    const fallbackScripts = Array.from(document.querySelectorAll('script[type="application/json"]'));
    for (const entry of fallbackScripts) {
      const parsed = safeParseJson(entry.textContent, null);
      if (
        parsed &&
        typeof parsed === 'object' &&
        Array.isArray(parsed.variants) &&
        (Array.isArray(parsed.options) || Array.isArray(parsed.options_with_values))
      ) {
        return parsed;
      }
    }

    return null;
  }

  function getOptionNames(productJson) {
    if (Array.isArray(productJson.options) && productJson.options.length) return productJson.options;
    if (Array.isArray(productJson.options_with_values)) {
      return productJson.options_with_values.map(function (item) {
        return item && item.name ? item.name : '';
      });
    }
    return [];
  }

  function findFirstOptionIndex(optionNames, candidates) {
    for (const candidate of candidates) {
      const idx = optionNames.findIndex(function (name) {
        return normalize(name) === normalize(candidate);
      });
      if (idx > -1) return idx;
    }
    return -1;
  }

  function extractLegendText(fieldset) {
    const legend = fieldset.querySelector('legend');
    if (!legend) return '';
    const clone = legend.cloneNode(true);
    clone.querySelectorAll('.variant-option__swatch-value').forEach(function (node) {
      node.remove();
    });
    return trimValue(clone.textContent || '');
  }

  function findControlByOptionName(form, optionName) {
    const target = normalize(optionName);
    if (!target) return null;

    const fieldsets = Array.from(form.querySelectorAll('fieldset'));
    for (const fieldset of fieldsets) {
      const name = extractLegendText(fieldset);
      if (normalize(name) !== target) continue;
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!radios.length) continue;
      return {
        getValue: function () {
          const checked = radios.find(function (radio) {
            return radio.checked;
          });
          return checked ? trimValue(checked.value) : '';
        },
      };
    }

    const selects = Array.from(form.querySelectorAll('select'));
    for (const select of selects) {
      const dataName = trimValue(select.getAttribute('data-option-name'));
      const attrName = trimValue((select.getAttribute('name') || '').replace(/^options\[|\]$/g, ''));
      if (normalize(dataName) !== target && normalize(attrName) !== target) continue;
      return {
        getValue: function () {
          return trimValue(select.value);
        },
      };
    }

    return null;
  }

  function getSelectedOptions(optionNames, form, variantPicker) {
    return optionNames.map(function (optionName) {
      const control = findControlByOptionName(form, optionName);
      if (control) return control.getValue();

      // Fallback for themes that track selected option attributes
      const selected = variantPicker.querySelector('fieldset input:checked, select option[selected]');
      if (selected instanceof HTMLOptionElement) return trimValue(selected.value);
      if (selected instanceof HTMLInputElement) return trimValue(selected.value);
      return '';
    });
  }

  function resolveAssetsBase(contextElement) {
    if (contextElement instanceof Element) {
      const gallery = contextElement.closest('media-gallery');
      if (gallery && gallery.dataset && gallery.dataset.assetsBase) {
        return gallery.dataset.assetsBase;
      }
    }

    const galleryWithBase = document.querySelector('media-gallery[data-assets-base]');
    if (galleryWithBase && galleryWithBase.dataset && galleryWithBase.dataset.assetsBase) {
      return galleryWithBase.dataset.assetsBase;
    }

    const scriptWithSrc = document.querySelector('script[src*="dynamic-preview.js"]');
    if (scriptWithSrc instanceof HTMLScriptElement && scriptWithSrc.src) {
      return scriptWithSrc.src.replace(/dynamic-preview\.js(?:\?.*)?$/, '');
    }

    return '/assets/';
  }

  function assetUrl(fileName, assetsBase) {
    if (!fileName) return '';
    if (/^(https?:)?\/\//i.test(fileName) || fileName.charAt(0) === '/') return fileName;
    const base = assetsBase || '/assets/';
    return base + encodeURIComponent(fileName).replace(/%2F/g, '/');
  }

  function setLayerImage(img, fileName, assetsBase) {
    if (!img) return;
    if (!fileName) {
      img.hidden = true;
      img.removeAttribute('src');
      return;
    }

    img.src = assetUrl(fileName, assetsBase);
    img.hidden = false;
  }

  function resolveGallery(state) {
    if (state.layer && state.layer.isConnected) {
      const gallery = state.layer.closest('media-gallery');
      if (gallery) return gallery;
    }

    const liveLayer = document.querySelector('[data-dynamic-preview-layer]');
    if (liveLayer instanceof HTMLElement) {
      return liveLayer.closest('media-gallery');
    }

    return null;
  }

  function getPreviewSlideIndex(gallery, slideshow) {
    if (!(gallery instanceof Element)) return PREVIEW_SLIDE_INDEX;

    const liveLayer = gallery.querySelector('[data-dynamic-preview-layer]');
    const previewSlide = liveLayer ? liveLayer.closest('slideshow-slide') : null;
    if (!(previewSlide instanceof HTMLElement)) return PREVIEW_SLIDE_INDEX;

    const slideList =
      slideshow && slideshow.refs && Array.isArray(slideshow.refs.slides)
        ? slideshow.refs.slides
        : Array.from(gallery.querySelectorAll('slideshow-slide'));

    const resolvedIndex = slideList.findIndex(function (slide) {
      return slide === previewSlide;
    });

    return resolvedIndex > -1 ? resolvedIndex : PREVIEW_SLIDE_INDEX;
  }

  function goToPreviewSlide(state) {
    const gallery = resolveGallery(state);
    if (!gallery) return false;

    const slideshow = gallery.querySelector('slideshow-component');
    const previewIndex = getPreviewSlideIndex(gallery, slideshow);
    if (
      slideshow &&
      typeof slideshow.select === 'function' &&
      slideshow.refs &&
      Array.isArray(slideshow.refs.slides) &&
      slideshow.refs.slides.length > previewIndex
    ) {
      try {
        slideshow.setAttribute('initial-slide', String(previewIndex));
        slideshow.select(previewIndex, undefined, { animate: false });
        return true;
      } catch (_error) {
        // continue with fallback strategies
      }
    }

    const slides = gallery.querySelectorAll('slideshow-slide');
    if (
      slides.length > previewIndex &&
      slides[previewIndex] instanceof HTMLElement &&
      slides[previewIndex].getAttribute('aria-hidden') !== 'true'
    ) {
      return true;
    }

    const controls = gallery.querySelectorAll(
      '.slideshow-controls__thumbnails .slideshow-control, .slideshow-controls__dots .slideshow-control'
    );
    if (controls.length > previewIndex && controls[previewIndex] instanceof HTMLElement) {
      controls[previewIndex].click();
      return true;
    }

    const updatedSlides = gallery.querySelectorAll('slideshow-slide');
    if (updatedSlides.length > previewIndex && updatedSlides[previewIndex] instanceof HTMLElement) {
      updatedSlides[previewIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      return true;
    }

    return false;
  }

  function forceThirdSlideInGallery(gallery) {
    if (!(gallery instanceof Element)) return false;

    const slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow || typeof slideshow.select !== 'function') return false;
    const previewIndex = getPreviewSlideIndex(gallery, slideshow);
    if (
      !slideshow.refs ||
      !Array.isArray(slideshow.refs.slides) ||
      slideshow.refs.slides.length <= previewIndex
    ) {
      return false;
    }

    try {
      if (typeof slideshow.current === 'number' && slideshow.current === previewIndex) {
        return true;
      }
      slideshow.setAttribute('initial-slide', String(previewIndex));
      slideshow.select(previewIndex, undefined, { animate: false });
      return true;
    } catch (_error) {
      return false;
    }
  }

  function forceThirdSlideEverywhere() {
    const galleries = document.querySelectorAll('media-gallery');
    let moved = false;
    galleries.forEach(function (gallery) {
      if (forceThirdSlideInGallery(gallery)) {
        moved = true;
      }
    });
    return moved;
  }

  function scheduleGoToPreviewSlide(state, delay) {
    if (state.goToPreviewTimer) {
      clearTimeout(state.goToPreviewTimer);
    }

    state.goToPreviewTimer = setTimeout(function () {
      const moved = goToPreviewSlide(state);
      state.goToPreviewTimer = null;

      if (moved) {
        state.switchedToPreview = true;
        state.switchRetries = 0;
        return;
      }

      if (state.switchRetries < 6) {
        state.switchRetries += 1;
        scheduleGoToPreviewSlide(state, 120);
      }
    }, delay || 0);
  }

  function startPreviewLock() {}

  function stopPreviewLock(state) {
    state.previewLockInterval = null;
    state.onSlideshowSelect = null;
  }

  function initLayer(layer) {
    if (!(layer instanceof HTMLElement)) return;
    if (layer.dataset.dynamicPreviewInit === 'true') return;

    const gallery = layer.closest('media-gallery');
    if (!gallery) return;

    const variantPicker = document.querySelector('variant-picker');
    const form = variantPicker ? variantPicker.querySelector('form') : document.querySelector('form[action*="/cart/add"]');
    if (!variantPicker || !form) return;

    const productJson = getProductJson();
    if (!productJson) return;

    const optionNames = getOptionNames(productJson);
    if (!optionNames.length) return;

    const idxCells = findFirstOptionIndex(optionNames, ['Typ komórek', 'Color', 'Typ komorek']);
    const idxCarpet = findFirstOptionIndex(optionNames, ['Kolor dywanika']);
    const idxTrim = findFirstOptionIndex(optionNames, ['Kolor obszycia']);

    const carpetScript = gallery.querySelector('script[type="application/json"][data-carpet-map]');
    const trimScript = gallery.querySelector('script[type="application/json"][data-trim-overlay-map]');
    const carpetMap = carpetScript ? safeParseJson(carpetScript.textContent, {}) : {};
    const trimMap = trimScript ? safeParseJson(trimScript.textContent, {}) : {};

    const imgCarpet = layer.querySelector('[data-dynamic-carpet]');
    const imgTrim = layer.querySelector('[data-dynamic-trim]');
    const previewWrap = layer.querySelector('.dynamic-preview-wrap');
    if (!(imgCarpet instanceof HTMLImageElement) || !(imgTrim instanceof HTMLImageElement)) return;

    const state = {
      hasInteraction: isGlobalThirdSlideLockEnabled(),
      switchedToPreview: isGlobalThirdSlideLockEnabled(),
      goToPreviewTimer: null,
      fallbackTimer: null,
      switchRetries: 0,
      previewLockInterval: null,
      onSlideshowSelect: null,
      layer: layer,
    };
    state.assetsBase = resolveAssetsBase(layer);

    const syncWrapAspect = function () {
      if (!(previewWrap instanceof HTMLElement)) return;
      if (!imgCarpet.naturalWidth || !imgCarpet.naturalHeight) return;
      previewWrap.style.aspectRatio = imgCarpet.naturalWidth + ' / ' + imgCarpet.naturalHeight;
    };

    imgCarpet.addEventListener('load', syncWrapAspect);

    function updatePreview() {
      const selectedOptions = getSelectedOptions(optionNames, form, variantPicker);
      const cellsVal = idxCells > -1 ? trimValue(selectedOptions[idxCells]) : '';
      const carpetVal = idxCarpet > -1 ? trimValue(selectedOptions[idxCarpet]) : '';
      const trimVal = idxTrim > -1 ? trimValue(selectedOptions[idxTrim]) : '';

      const carpetFile =
        carpetMap && typeof carpetMap === 'object' && carpetMap[cellsVal] && typeof carpetMap[cellsVal] === 'object'
          ? carpetMap[cellsVal][carpetVal] || null
          : null;
      const trimFile = trimMap && typeof trimMap === 'object' ? trimMap[trimVal] || null : null;

      setLayerImage(imgCarpet, carpetFile, state.assetsBase);
      setLayerImage(imgTrim, trimFile, state.assetsBase);
      if (imgCarpet.complete) {
        syncWrapAspect();
      }
    }

    function maybeSwitchToPreview(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const input = target.closest('input, select, button, .swatch-item');
      if (!input) return;

      const inPicker = Boolean(
        input.closest('[data-swatch-picker]') ||
          input.closest('variant-picker') ||
          (input instanceof HTMLInputElement && /Typ kom|Kolor dywanika|Kolor obszycia|Color/i.test(input.name))
      );
      if (!inPicker) return;
      enableGlobalThirdSlideLock();
      state.hasInteraction = true;
      scheduleGoToPreviewSlide(state, 40);
    }

    const onFormChange = function (event) {
      maybeSwitchToPreview(event);
      updatePreview();

      if (state.hasInteraction) {
        if (state.fallbackTimer) {
          clearTimeout(state.fallbackTimer);
        }

        // Fallback: if variant:update is not emitted in this template, still switch once.
        state.fallbackTimer = setTimeout(function () {
          scheduleGoToPreviewSlide(state, 80);
          state.fallbackTimer = null;
        }, 500);
      }
    };

    const onDocumentClick = function (event) {
      maybeSwitchToPreview(event);
    };

    const onVariantUpdate = function (event) {
      if (!state.hasInteraction) return;

      if (state.fallbackTimer) {
        clearTimeout(state.fallbackTimer);
        state.fallbackTimer = null;
      }

      // Wait a bit so Horizon finishes media selection before forcing the preview slide.
      scheduleGoToPreviewSlide(state, state.switchedToPreview ? 60 : 120);
    };

    form.addEventListener('change', onFormChange);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('variant:update', onVariantUpdate);

    updatePreview();
    if (isGlobalThirdSlideLockEnabled()) {
      scheduleGoToPreviewSlide(state, 0);
    }
    layer.dataset.dynamicPreviewInit = 'true';

    layer.__dynamicPreviewCleanup = function () {
      form.removeEventListener('change', onFormChange);
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('variant:update', onVariantUpdate);
      imgCarpet.removeEventListener('load', syncWrapAspect);
      if (state.goToPreviewTimer) {
        clearTimeout(state.goToPreviewTimer);
        state.goToPreviewTimer = null;
      }
      if (state.fallbackTimer) {
        clearTimeout(state.fallbackTimer);
        state.fallbackTimer = null;
      }
      stopPreviewLock(state);
      delete layer.__dynamicPreviewCleanup;
      layer.dataset.dynamicPreviewInit = 'false';
    };
  }

  function initAll(scope) {
    const root = scope instanceof Element ? scope : document;
    root.querySelectorAll('[data-dynamic-preview-layer]').forEach(function (layer) {
      initLayer(layer);
    });
    if (root instanceof Element && root.matches('[data-dynamic-preview-layer]')) {
      initLayer(root);
    }
  }

  function observeReRenders() {
    if (!document.body) return;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.removedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches('[data-dynamic-preview-layer]') && typeof node.__dynamicPreviewCleanup === 'function') {
            node.__dynamicPreviewCleanup();
          }
          node.querySelectorAll('[data-dynamic-preview-layer]').forEach(function (layer) {
            if (typeof layer.__dynamicPreviewCleanup === 'function') {
              layer.__dynamicPreviewCleanup();
            }
          });
        });

        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          initAll(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      observeReRenders();
      document.addEventListener('variant:update', function () {
        if (!isGlobalThirdSlideLockEnabled()) return;
      });
    });
  } else {
    initAll(document);
    observeReRenders();
    document.addEventListener('variant:update', function () {
      if (!isGlobalThirdSlideLockEnabled()) return;
    });
  }
})();

(function () {
  const MOBILE_BREAKPOINT = '(max-width: 749px)';
  const STICKY_ID = 'mobile-sticky-media';
  const STICKY_IMAGE_ID = 'mobile-sticky-media-img';
  const CONFIG_ID = 'car-config';

  const mobileQuery = window.matchMedia(MOBILE_BREAKPOINT);
  let galleryObserver = null;
  let rootObserver = null;
  let boundGallery = null;
  let boundSlideshow = null;
  let rafId = 0;
  let initialized = false;
  let stickyActivatedByConfigurator = false;

  function getSticky() {
    const sticky = document.getElementById(STICKY_ID);
    const image = document.getElementById(STICKY_IMAGE_ID);
    const stage = document.getElementById('mobile-sticky-media-stage');
    const carpet = document.getElementById('mobile-sticky-media-carpet');
    const trim = document.getElementById('mobile-sticky-media-trim');
    if (
      !(sticky instanceof HTMLElement) ||
      !(stage instanceof HTMLElement) ||
      !(image instanceof HTMLImageElement) ||
      !(carpet instanceof HTMLImageElement) ||
      !(trim instanceof HTMLImageElement)
    ) {
      return null;
    }
    return { sticky: sticky, stage: stage, image: image, carpet: carpet, trim: trim };
  }

  function getConfigurator() {
    const config = document.getElementById(CONFIG_ID);
    return config instanceof HTMLElement ? config : null;
  }

  function getScope(config) {
    return (
      config.closest('.product-information') ||
      config.closest('.shopify-section') ||
      document.querySelector('[data-testid="product-information"]') ||
      document
    );
  }

  function getGallery(config) {
    const scope = getScope(config);
    if (!(scope instanceof Element || scope instanceof Document)) return null;

    const scopedGallery =
      scope.querySelector('[data-testid="product-information-media"] media-gallery') ||
      scope.querySelector('media-gallery[data-presentation]');

    if (scopedGallery instanceof HTMLElement) return scopedGallery;

    const fallbackGallery = document.querySelector('media-gallery[data-presentation]');
    return fallbackGallery instanceof HTMLElement ? fallbackGallery : null;
  }

  function scheduleFrame(callback) {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      callback();
    });
  }

  function normalizeStickyOptionLabel(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function isStickyTriggerOptionLabel(value) {
    const normalized = normalizeStickyOptionLabel(value);
    return normalized === 'typ komorek' || normalized === 'kolor dywanika' || normalized === 'kolor obszycia';
  }

  function getStickyTriggerLabelFromNode(node) {
    if (!(node instanceof Element)) return '';

    const fieldset = node.closest('fieldset');
    if (fieldset) {
      const legend = fieldset.querySelector('legend');
      if (legend) return legend.textContent || '';
    }

    const optionRoot = node.closest('[data-option-name], [data-option-label]');
    if (optionRoot instanceof HTMLElement) {
      return optionRoot.dataset.optionName || optionRoot.dataset.optionLabel || '';
    }

    if (node instanceof HTMLInputElement || node instanceof HTMLSelectElement) {
      return node.getAttribute('data-option-name') || node.name || '';
    }

    return '';
  }

  function maybeActivateStickyFromEvent(event) {
    const target = event && event.target;
    if (!(target instanceof Element)) return;

    const label = getStickyTriggerLabelFromNode(target);
    if (!isStickyTriggerOptionLabel(label)) return;

    stickyActivatedByConfigurator = true;
    scheduleFrame(function () {
      updateStickyImage();
      updateStickyVisibility();
    });
  }

  function ensureStickyPlacement() {
    const parts = getSticky();
    if (!parts || !document.body) return;

    if (parts.sticky.parentNode === document.body) {
      return;
    }

    document.body.appendChild(parts.sticky);
  }

  function getSlideImage(slide) {
    if (!(slide instanceof Element)) return null;
    const image = slide.querySelector('.product-media__image');
    if (!(image instanceof HTMLImageElement)) return null;
    const hasSource = Boolean(image.currentSrc || image.getAttribute('src') || image.getAttribute('srcset'));
    return hasSource ? image : null;
  }

  function getActiveGalleryImage(gallery) {
    if (!(gallery instanceof HTMLElement)) return null;

    const slideshow = gallery.slideshow || gallery.querySelector('slideshow-component');
    if (slideshow && Array.isArray(slideshow.slides) && typeof slideshow.current === 'number') {
      const currentSlide = slideshow.slides[slideshow.current];
      const currentSlideImage = getSlideImage(currentSlide);
      if (currentSlideImage) return currentSlideImage;
    }

    const visibleSlide = gallery.querySelector('slideshow-slide[aria-hidden="false"]');
    const visibleSlideImage = getSlideImage(visibleSlide);
    if (visibleSlideImage) return visibleSlideImage;

    const selectedMediaImage = gallery.querySelector(
      '.product-media-container[aria-current="true"] .product-media__image, .product-media-container[selected] .product-media__image'
    );
    if (selectedMediaImage instanceof HTMLImageElement) return selectedMediaImage;

    const eagerImage = gallery.querySelector('.product-media__image[fetchpriority="high"], .product-media__image');
    if (eagerImage instanceof HTMLImageElement) return eagerImage;

    const firstImage = gallery.querySelector('.product-media__image');
    return firstImage instanceof HTMLImageElement ? firstImage : null;
  }

  function clearSticky() {
    const parts = getSticky();
    if (!parts) return;
    parts.sticky.hidden = true;
    parts.image.removeAttribute('src');
    parts.image.removeAttribute('srcset');
    parts.image.alt = '';
    parts.carpet.removeAttribute('src');
    parts.carpet.hidden = true;
    parts.trim.removeAttribute('src');
    parts.trim.hidden = true;
  }

  function hideSticky() {
    const parts = getSticky();
    if (!parts) return;
    parts.sticky.hidden = true;
  }

  function syncStageAspect(parts, sourceImage) {
    if (!parts || !sourceImage) return;
    const width = sourceImage.naturalWidth;
    const height = sourceImage.naturalHeight;
    if (width && height) {
      parts.stage.style.aspectRatio = width + ' / ' + height;
    }
  }

  function syncOverlayImage(target, source) {
    if (!(target instanceof HTMLImageElement)) return;
    if (!(source instanceof HTMLImageElement) || source.hidden) {
      target.removeAttribute('src');
      target.hidden = true;
      return;
    }

    const src = source.currentSrc || source.getAttribute('src') || '';
    if (!src) {
      target.removeAttribute('src');
      target.hidden = true;
      return;
    }

    if (target.src !== src) {
      target.src = src;
    }

    const srcset = source.getAttribute('srcset') || '';
    if (srcset) {
      target.setAttribute('srcset', srcset);
    } else {
      target.removeAttribute('srcset');
    }

    target.alt = source.getAttribute('alt') || '';
    target.hidden = false;
  }

  function updateStickyImage() {
    const parts = getSticky();
    const config = getConfigurator();
    if (!parts || !config || !mobileQuery.matches) return clearSticky();

    ensureStickyPlacement();

    const gallery = getGallery(config);
    const activeImage = getActiveGalleryImage(gallery);
    if (!activeImage) return clearSticky();

    const nextSrc = activeImage.currentSrc || activeImage.getAttribute('src') || '';
    if (!nextSrc) return clearSticky();

    if (parts.image.src !== nextSrc) {
      parts.image.src = nextSrc;
    }

    const nextSrcset = activeImage.getAttribute('srcset') || '';
    if (parts.image.getAttribute('srcset') !== nextSrcset) {
      if (nextSrcset) {
        parts.image.setAttribute('srcset', nextSrcset);
      } else {
        parts.image.removeAttribute('srcset');
      }
    }

    const nextSizes = activeImage.getAttribute('sizes') || '100vw';
    if (parts.image.getAttribute('sizes') !== nextSizes) {
      parts.image.setAttribute('sizes', nextSizes);
    }

    const alt = activeImage.getAttribute('alt') || '';
    if (parts.image.alt !== alt) {
      parts.image.alt = alt;
    }

    syncStageAspect(parts, activeImage);

    const activeSlide = activeImage.closest('slideshow-slide, .product-media-container');
    const activeLayer = activeSlide ? activeSlide.querySelector('[data-dynamic-preview-layer]') : null;
    const activeCarpet = activeLayer ? activeLayer.querySelector('[data-dynamic-carpet]') : null;
    const activeTrim = activeLayer ? activeLayer.querySelector('[data-dynamic-trim]') : null;

    syncOverlayImage(parts.carpet, activeCarpet);
    syncOverlayImage(parts.trim, activeTrim);

    updateStickyVisibility();
  }

  function updateStickyVisibility() {
    const parts = getSticky();
    const config = getConfigurator();
    const gallery = getGallery(config);
    if (
      !parts ||
      !config ||
      !gallery ||
      !mobileQuery.matches ||
      !stickyActivatedByConfigurator ||
      !parts.image.getAttribute('src')
    ) {
      clearSticky();
      return;
    }

    ensureStickyPlacement();

    const stickyTop = parseFloat(window.getComputedStyle(parts.sticky).top || '0') || 0;
    const galleryRect = gallery.getBoundingClientRect();
    const configRect = config.getBoundingClientRect();
    const pastGallery = galleryRect.bottom <= stickyTop + 8;
    const beforeConfigEnd = configRect.bottom > stickyTop + 32;

    parts.sticky.hidden = !(pastGallery && beforeConfigEnd);
  }

  function bindGalleryObservers() {
    const config = getConfigurator();
    const gallery = getGallery(config);
    if (!(gallery instanceof HTMLElement)) {
      if (galleryObserver) {
        galleryObserver.disconnect();
        galleryObserver = null;
      }
      if (boundSlideshow) {
        boundSlideshow.removeEventListener('slideshow:select', onGalleryChange);
        boundSlideshow = null;
      }
      boundGallery = null;
      return;
    }

    if (boundGallery === gallery) return;

    if (galleryObserver) {
      galleryObserver.disconnect();
      galleryObserver = null;
    }

    if (boundSlideshow) {
      boundSlideshow.removeEventListener('slideshow:select', onGalleryChange);
      boundSlideshow = null;
    }

    boundGallery = gallery;

    const slideshow = gallery.slideshow || gallery.querySelector('slideshow-component');
    if (slideshow instanceof HTMLElement) {
      boundSlideshow = slideshow;
      boundSlideshow.addEventListener('slideshow:select', onGalleryChange);
    }

    galleryObserver = new MutationObserver(function (mutations) {
      const shouldSync = mutations.some(function (mutation) {
        return mutation.type === 'childList' || mutation.attributeName === 'aria-hidden' || mutation.attributeName === 'src';
      });

      if (shouldSync) {
        scheduleFrame(updateStickyImage);
      }
    });

    galleryObserver.observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'src', 'srcset'],
    });
  }

  function onGalleryChange() {
    scheduleFrame(updateStickyImage);
  }

  function onScrollOrResize() {
    scheduleFrame(updateStickyVisibility);
  }

  function ensureRootObserver() {
    if (rootObserver || !document.body) return;

    rootObserver = new MutationObserver(function () {
      scheduleFrame(function () {
        bindGalleryObservers();
        updateStickyImage();
      });
    });

    rootObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

 function initMobileStickyMedia() {
  const config = getConfigurator();

  if (!config) {
    hideSticky();
    return;
  }

  if (!mobileQuery.matches) {
    hideSticky();
    return;
  }

  const parts = getSticky();
  if (!parts) {
    hideSticky();
    return;
  }

  ensureStickyPlacement();
  bindGalleryObservers();
  updateStickyImage();
  ensureRootObserver();
}

  function setup() {
    if (initialized) return;
    if (!getConfigurator()) {
    return;
  }
     if (!document.getElementById(CONFIG_ID)) {
    return;
  }
    initialized = true;

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    document.addEventListener('change', maybeActivateStickyFromEvent, true);
    document.addEventListener('click', maybeActivateStickyFromEvent, true);
    document.addEventListener('variant:update', function () {
      scheduleFrame(function () {
        bindGalleryObservers();
        updateStickyImage();
      });
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', initMobileStickyMedia);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(initMobileStickyMedia);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
      initMobileStickyMedia();
    });
  } else {
    setup();
    initMobileStickyMedia();
  }
})();
